import { jsx as _jsx } from "react/jsx-runtime";
import { clsx, Heading } from '@a-type/ui';
import cls from './Wordmark.module.css';
export function Wordmark({ className, ...rest }) {
    return (_jsx(Heading, { emphasis: "secondary", className: clsx('font-fancy', cls.root, className), ...rest, children: "rout!" }));
}
//# sourceMappingURL=Wordmark.js.map